import { IconCopy } from '@tabler/icons-react';
import { useFela } from 'react-fela';
import { useIntl } from 'react-intl';

import { useCopyToClipboard } from '@/modules/ui';

import * as felaRules from './CopyIconButton.rules';

export interface CopyIconButtonProps {
    value: string;
    iconSize?: number;
    'data-testid'?: string;
}

export const CopyIconButton = ({ value, iconSize = 24, 'data-testid': dataTestId }: CopyIconButtonProps) => {
    const { css } = useFela();
    const { formatMessage } = useIntl();

    const { handleCopy } = useCopyToClipboard();

    return (
        <button
            type='button'
            className={css(felaRules.button)}
            onClick={() => handleCopy(value)}
            aria-label={formatMessage({ id: 'copy' })}
            data-testid={dataTestId}
        >
            <IconCopy size={iconSize} />
        </button>
    );
};
